import { useId } from 'react';
import type { ILabeledTextareaProps } from '@/@types/photostudio';
import { cn } from '@/lib/utils';

export function LabeledTextarea({
  label,
  value,
  onChange,
  placeholder = '',
  rows = 3,
  disabled = false,
}: ILabeledTextareaProps) {
  const id = useId();

  return (
    <div className="flex flex-col gap-1.5 w-full">
      <label
        htmlFor={id}
        className="text-[11px] font-semibold uppercase tracking-wider text-accent"
      >
        {label}
      </label>
      <textarea
        id={id}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        className={cn(
          'w-full rounded-md px-3 py-2 text-sm',
          'bg-background-input border border-border',
          'text-foreground placeholder:text-foreground-placeholder',
          'hover:border-border-hover',
          'focus:outline-none focus:border-accent',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          'transition-colors',
          'resize-none'
        )}
      />
    </div>
  );
}
